import { useMemo, memo } from "react";
import Chart from "react-apexcharts";
import './chart.css';

function safeParse(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    console.error("Erro ao parsear JSON:", e);
    return [];
  }
}

function ChartLine2({
  data,
  categoryKey,
  valueKey,
  percentageKey,
  chartType = "line",
  titleX,
  titleY,
  seriesNames = [],
  showPercentage = true,
}) {
  const categories = useMemo(
    () => {
      if (!data) return [];
      const firstKey = Object.keys(data)[0];
      return firstKey ? safeParse(data[firstKey]).map((item) => item[categoryKey]) : [];
    },
    [data, categoryKey]
  );

  const series = useMemo(
    () => !data ? [] : Object.keys(data).map((key, index) => {
      const currentData = safeParse(data[key]);
      return {
        name: seriesNames[index] || key,
        data: showPercentage
          ? currentData.map((item) => item[percentageKey])
          : currentData.map((item) => item[valueKey]),
      };
    }),
    [data, seriesNames, showPercentage, percentageKey, valueKey]
  );

  const options = useMemo(
    () => ({
      chart: { type: chartType },
      dataLabels: {
        enabled: true,
        formatter: (val) => showPercentage ? `${val.toFixed(0)}%` : val,
      },
      xaxis: {
        categories,
        title: { text: titleX, style: { color: "var(--text-50)" } },
        labels: { style: { colors: "var(--text-50)" } },
      },
      yaxis: {
        title: { text: titleY, style: { color: "var(--text-50)" } },
        labels: {
          style: { colors: "var(--text-50)" },
          formatter: (val) => showPercentage ? `${val.toFixed(0)}%` : val,
        },
      },
      tooltip: {
        y: { formatter: (val) => showPercentage ? `${val.toFixed(2)}%` : val },
      },
      legend: { labels: { colors: "var(--text-50)" } },
    }),
    [chartType, showPercentage, categories, titleX, titleY]
  );

  return (
    <Chart options={options} series={series} type={chartType} height="100%" width="100%" />
  );
}

export default memo(ChartLine2);
